// The overview tiles: today's numbers at a glance.
import { z } from 'zod'

const count = z.number().int().min(0)

export const Overview = z.object({
  campaigns_sending: count,
  waiting_approval: count,
  vendor_changes_waiting: count.describe('vendor changes waiting for a second person'),
  voice_messages_waiting: count.describe('voice messages waiting for a second person'),
  wa_sent_today: count,
  ivr_calls_today: count,
  wa_usable: count.describe('WhatsApp numbers connected and not rated low'),
  wa_total: count,
  suppressed: count,
  leads: count,
})
export type Overview = z.infer<typeof Overview>

export interface OverviewApi {
  getOverview(): Promise<Overview>
}
